module.exports = __webpack_public_path__ + "static/media/card-index-middle-1.f47ef85a.jpg";